<template>
  <div class="farm-overview-page">
    <HeaderNav />
    <el-row :gutter="20">
      <!-- 左侧主区域 -->
      <el-col :span="17">
        <!-- 顶部农场概览统计卡片 -->
        <el-card class="stat-card" shadow="never">
          <div class="card-title">农场概览</div>
          <div class="stat-row">
            <div class="stat-item">
              <!-- 环形图DOM容器，固定宽高 -->
              <div ref="rateChart" class="rate-chart"></div>
            </div>

            <div class="stat-item">
              <div class="num-text">{{ allLandAcre }}亩</div>
              <div class="num-label">地块总面积</div>
            </div>
            <div class="stat-divider"></div>
            <div class="stat-item">
              <div class="num-text">{{ allLandAcreOnPlanting }}亩</div>
              <div class="num-label">当前种养面积</div>
            </div>
            <div class="stat-divider"></div>
            <div class="stat-item stat-map">
              <div class="num-text">{{ totalPlantNum }}种</div>
              <div class="num-label">当前种养品种</div>
            </div>
          </div>
        </el-card>

        <!-- 当前种养品种区域 -->
        <el-card class="breed-card" shadow="never">
          <div class="card-title">当前种养品种</div>
          <div class="breed-list">
            <!-- 种植品类 -->
            <div class="breed-item" v-for="(item, idx) in breedList" :key="idx">
              <div class="breed-img">
                <img :src="item.imgUrl" alt="" />
              </div>
              <div class="breed-name">{{ item.cropName }}</div>
              <div class="breed-desc" v-if="item.cropSubjectId == 3">
                养殖数量：<span>{{ item.plantNum }}</span
                >{{ item.cropCategoryUnit }}
              </div>
              <div class="breed-desc" v-else>
                {{ returnPlantingOrFarming(item.cropSubjectId) }}面积：<span>{{
                  item.landAcre
                }}</span
                >亩
              </div>
              <div class="breed-btns">
                <el-button
                  type="success"
                  plain
                  v-if="item.cropSubjectId != 3 || !item.farmEarTagCount"
                  @click="handleHarvest(item)"
                >
                  {{ returnAction(item.cropSubjectId) }}
                </el-button>
                <el-button
                  plain
                  v-if="item.cropSubjectId != 3 || !item.farmEarTagCount"
                  @click="clickEndPlanting(item)"
                  >结束</el-button
                >
              </div>
            </div>
          </div>
        </el-card>
      </el-col>

      <!-- 右侧侧边栏 -->
      <el-col :span="7">
        <!-- 常用操作 -->
        <el-card class="side-card" shadow="never">
          <div class="card-title">常用操作</div>
          <div class="operate-grid">
            <div
              class="operate-btn"
              v-for="(op, idx) in operateList"
              :key="idx"
              :style="{ backgroundColor: op.bg }"
              ,
              @click="goPage(op.url)"
            >
              <img :src="getImgUrl(op.icon)" alt="" />
              <span>{{ op.label }}</span>
            </div>
          </div>
        </el-card>

        <!-- 生产记录 -->
        <el-card class="side-card" shadow="never">
          <div class="side-card-header">
            <div class="card-title">生产记录</div>
            <span class="more-link" @click="handleDetailed">明细»</span>
          </div>
          <div class="record-wrap">
            <div class="record-top">
              <span class="record-label">本年农事操作</span>
            </div>
            <div class="record-num">
              {{ missionCount }}<span class="record-unit">次</span>
            </div>
            <div class="stat-grid" v-if="missionList.length > 0">
              <!-- 循环渲染每一项农事统计卡片 -->
              <div
                class="stat-card-new"
                v-for="(item, index) in missionList"
                :key="index"
              >
                <span class="stat-label">{{ item.missionCategoryName }}</span>
                <span class="stat-num">{{ item.count }}次</span>
              </div>
            </div>

            <div v-else class="empty-tip">当前暂无农事操作</div>
          </div>
        </el-card>

        <!-- 农资库存 -->
        <el-card class="side-card" shadow="never">
          <div class="side-card-header">
            <div class="card-title">农资库存</div>
            <span class="more-link" @click="handleStockDetailed">明细»</span>
          </div>

          <div v-if="stockList.length > 0">
            <div
              class="stock-card"
              v-for="(item, index) in stockList"
              :key="index"
            >
              <div class="stock-name">{{ item.firstAgriResCategoryName }}</div>
              <div class="stock-info">
                <span class="stock-text">剩余库存</span>
                <span class="stock-num">{{ item.stockValueInMeter }} 公斤</span>
              </div>
            </div>
          </div>

          <div class="empty-tip" v-else>当前暂无库存</div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  getFarmInfoService,
  onPlantingByFarmIdService,
  getMissionInfoService,
  getAgriResSkuService,
} from "@/api/request/snkd.hsdt";
import { windowHref } from "@/utils";
import HeaderNav from "./components/HeaderNav.vue";
import * as echarts from "echarts";
export default {
  components: { HeaderNav },
  data() {
    return {
      stockList: [],
      missionList: [],
      missionCount: 0,
      companyId: "",
      farmId: "",
      allLandAcre: 0,
      allLandAcreOnPlanting: 0,
      useRate: 10, // 地块使用率，可接口动态赋值
      chartInstance: null,
      // 种养品种数据
      breedList: [],
      // 右侧操作按钮
      operateList: [
        {
          label: "添加种养品种",
          bg: "#e6f7ff",
          icon: "add-breed",
          url: "/home/batchplan",
        },
        {
          label: "农事操作",
          bg: "#fff2e8",
          icon: "farmwork",
          url: "/home/addfarmnotes",
        },
        {
          label: "农资入库",
          bg: "#f0f7ff",
          icon: "agrires",
          url: "/agriresstorage/agriresadmin",
        },
        {
          label: "销售农产品",
          bg: "#f0fff4",
          icon: "sale",
          url: "/agriproductstorage/list",
        },
      ],
      progress: 0, // 进度（0-100）
      titleText: "地块使用率", // 标题文本
      percentText: "", // 百分比文本
      totalPlantNum: 0,
    };
  },

  methods: {
    getAgriResSku() {
      getAgriResSkuService({
        companyId: this.companyId,
        farmId: this.farmId,
      }).then((res) => {
        this.stockList = res.obj || [];
      });
    },

    handleStockDetailed() {
      windowHref("/agriresstorage/agriresstorage", {
        company: this.companyId,
        farm: this.farmId,
      });
    },
    handleDetailed() {
      windowHref("/home/batch", {
        tab: 1,
        company: this.companyId,
        farm: this.farmId,
        periodType: 1,
      });
    },

    getMissionInfo() {
      getMissionInfoService({
        companyId: this.companyId,
        farmId: this.farmId,
        period: 1,
      }).then((res) => {
        console.log(85699, res);
        this.missionList = res.obj.missionCategorySummaryList || [];
        this.missionCount = res.obj.missionCount;
      });
    },
    clickEndPlanting(item) {
      windowHref("/endplanting/endplanting", {
        company: this.companyId,
        farm: this.farmId,
        cropSubjectId: item.cropSubjectId,
        cropId: item.cropId,
      });
    },
    handleHarvest(item) {
      if (item.cropSubjectId == 1 || item.cropSubjectId == 4) {
        windowHref("/home/batch-picking", {
          company: this.companyId,
          farm: this.farmId,
          cropId: item.cropId,
        });
      } else {
        this.$message({
          message: `请前往「地块管理-地块详情」页面进行${this.returnPlantingOrFarming(
            item.cropSubjectId
          )}操作`,
          type: "warning",
        });
      }
    },
    returnPlantingOrFarming(cropSubjectId) {
      if (cropSubjectId === 3 || cropSubjectId === 4) {
        return "养殖";
      } else {
        return "种植";
      }
    },

    // 返回动作"采收"/"捕捞"/"出栏"
    returnAction(cropSubjectId) {
      if (cropSubjectId === 1 || cropSubjectId === 2) {
        return "采收";
      } else if (cropSubjectId === 3) {
        return "出栏";
      } else if (cropSubjectId === 4) {
        return "捕捞";
      }
    },
    //获取农场数据详情
    getFarmInfo() {
      getFarmInfoService({
        companyId: this.companyId,
        farmId: this.farmId,
      }).then((res) => {
        if (res.respCode == 0) {
          this.allLandAcre = res.obj.allLandAcre;
          this.allLandAcreOnPlanting = res.obj.allLandAcreOnPlanting;
          this.progress = Math.floor(
            (this.allLandAcreOnPlanting / this.allLandAcre) * 100
          );
          this.percentText = this.progress + "%";
        }
      });
    },

    getPlantList() {
      onPlantingByFarmIdService({
        companyId: this.companyId,
        farmId: this.farmId,
      }).then((res) => {
        console.log(999, res);
        if (res.respCode == 0) {
          this.breedList = res.obj.list || [];
          this.totalPlantNum = res.obj.totalCount || 0;
        }
      });
    },
    //页面跳转
    goPage(url) {
      windowHref(url, {
        companyId: this.companyId,
        farmId: this.farmId,
      });
    },
    initChart() {
      this.chartInstance = echarts.init(this.$refs.rateChart);
    },

    getImgUrl(name) {
      return require(`@/assets/images/hsdt/${name}.png`);
    },

    // 配置并更新图表
    updateChart() {
      const option = {
        // 提示框（隐藏，按需启用）
        tooltip: { show: false },
        // 图形组件（调整间距）
        graphic: [
          {
            type: "group",
            left: "center",
            top: "center",
            children: [
              // 标题文字（地块使用率）
              {
                type: "text",
                z: 10,
                style: {
                  text: this.titleText,
                  fontSize: 16,
                  fontWeight: "normal",
                  fill: "#333", // 文字颜色（深灰）
                },
              },
              {
                type: "text",
                z: 10,
                top: 26,
                left: 14,
                style: {
                  text: this.percentText,
                  fontSize: 24,
                  fontWeight: "bold",
                  fill: "#333", // 文字颜色（深灰）
                  marginTop: 10, // 与标题的间距
                },
              },
            ],
          },
        ],
        // 饼图配置（模拟环形）
        series: [
          {
            type: "pie",
            radius: ["70%", "85%"],
            center: ["50%", "50%"],
            startAngle: 90,
            avoidLabelOverlap: false,
            itemStyle: {
              // 高亮区块（进度部分）：绿色描边
              emphasis: {
                scale: false,
                itemStyle: {
                  borderWidth: 0,
                  shadowBlur: 0,
                },
              },
            },
            label: { show: false }, // 隐藏默认标签
            labelLine: { show: false }, // 隐藏标签线
            data: [
              // 进度部分（高亮色，占 progress%）
              {
                value: this.progress,
                itemStyle: {
                  color: "#67C23A", // 绿色（与示例匹配）
                  borderWidth: 0,
                  borderRadius: 0,
                },
              },
              {
                value: 100 - this.progress,
                itemStyle: {
                  color: "transparent", // 透明背景
                  borderWidth: 0,
                },
              },
            ],
          },
        ],
      };
      // 渲染图表
      this.chartInstance.setOption(option);
    },
  },

  mounted() {
    this.companyId = JSON.parse(localStorage.getItem("FARMINFO")).companyId;
    this.farmId = JSON.parse(localStorage.getItem("FARMINFO")).farmId;
    this.getFarmInfo();
    this.getPlantList();
    this.getMissionInfo();
    this.getAgriResSku();
    setTimeout(() => {
      this.initChart();
      this.updateChart();
    }, 500);
    // 窗口自适应重绘
    window.addEventListener("resize", () => {
      this.chartInstance.resize();
    });
  },
  beforeDestroy() {
    // 销毁图表释放内存
    if (this.chartInstance) {
      this.chartInstance.dispose();
      this.chartInstance = null;
    }
    window.removeEventListener("resize", () => {});
  },
};
</script>

<style lang="scss" scoped>
.farm-overview-page {
  padding: 20px;
  background: #f7f8fa;
  min-height: 100vh;
}

// 通用卡片标题
.card-title {
  text-align: center;
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 24px;
  color: #333;
}

// 顶部统计卡片
.stat-card {
  margin-bottom: 20px;
  padding: 24px 16px;

  .stat-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }

  .stat-item {
    flex: 1;
    text-align: center;

    &.stat-map {
      flex: 1.2;
    }
    .rate-chart {
      width: 160px;
      height: 160px;
      margin: 0 auto;
    }
  }

  .num-text {
    font-size: 26px;
    font-weight: 500;
    color: #333;
    margin-bottom: 10px;
  }

  .num-label {
    font-size: 16px;
    color: #666;
    margin-top: 6px;
  }

  .map-box {
    position: relative;

    img {
      width: 80px;
      height: 60px;
      object-fit: cover;
      border-radius: 4px;
    }

    .map-tip {
      position: absolute;
      right: 0;
      top: 0;
      font-size: 12px;
      color: #096dd9;
    }
  }
}

// 种养品种卡片
.breed-card {
  padding: 24px 16px;

  .breed-list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    gap: 16px;
    margin-left: 70px;
  }

  .breed-item {
    background-color: rgba(239, 243, 248, 0.5);
    border: 1px solid #eee;
    border-radius: 8px;
    padding: 16px 10px;
    text-align: center;
    width: 13%;
    .breed-img {
      width: 80px;
      height: 80px;
      margin: 0 auto 12px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        object-fit: cover;
      }
    }

    .breed-name {
      font-size: 15px;
      color: #333;
      font-weight: 500;
    }

    .breed-desc {
      font-size: 16px;
      color: #999;
      margin: 10px 0 12px;
    }

    .breed-btns {
      display: flex;
      gap: 8px;
      justify-content: center;
    }
  }
}

// 右侧侧边栏卡片通用
.side-card {
  margin-bottom: 16px;
  padding: 16px;

  .side-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    .card-title {
      margin-bottom: 0;
      text-align: left;
      font-size: 20px;
    }

    .more-link {
      font-size: 16px;
      color: #096dd9;
      cursor: pointer;
    }
  }
  .stock-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 15px;
    background-color: #f0f6fc;
    border-radius: 10px;
    margin: 10px;

    .stock-name {
      font-size: 20px;
      color: #607289;
      font-weight: 500;
      word-break: break-all;
    }
    .stock-info {
      display: flex;
      align-items: baseline;
      gap: 16px;
      color: #8294ab;
      .stock-text {
        font-size: 18px;
      }
      .stock-num {
        font-size: 18px;
        font-weight: 500;
      }
    }
  }

  .empty-tip {
    text-align: center;
    color: #999;
    padding: 20px 0;
  }
}

// 常用操作网格
.operate-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;

  .operate-btn {
    display: flex;
    align-items: center;
    // justify-content: center;
    gap: 6px;
    padding: 10px 4px;
    border-radius: 6px;
    font-size: 13px;
    color: #333;
    height: 40px;
    cursor: pointer;

    img {
      width: 20px;
      height: 20px;
      margin-left: 30px;
    }
    span {
      font-size: 16px;
      font-weight: bold;
      margin-left: 10px;
    }
  }
}

// 生产记录模块
.record-wrap {
  .record-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;

    .record-label {
      font-size: 16px;
      color: #666;
    }
  }

  .record-num {
    font-size: 32px;
    font-weight: bold;
    color: #333;

    .record-unit {
      font-size: 14px;
      font-weight: normal;
      color: #999;
    }
  }
  .stat-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    margin-top: 20px;
  }
  .stat-card-new {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    height: 30px;
    background-color: #f0f5fb;
    border-radius: 8px;
    cursor: pointer;
    .stat-label {
      font-size: 20px;
      color: #333;
    }
    .stat-num {
      font-size: 22px;
      color: #444;
      font-weight: 500;
    }
  }

  .stat-card-new:hover {
    background-color: #e6f7ff;
    transition: linear 0.3s;
  }
}
</style>
